import { all } from "redux-saga/effects";

import allOrderSagas from "./allOrders";
import crudOrderSagas from "./crudOrder";

export default function* ordersSagas() {
  yield all([allOrderSagas(), crudOrderSagas()]);
}
